var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { accountSummaryV2CacheKey } from "@syf-api-library/account-summary";
import { Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import links from "../../../../const/links";
import modalIds from "../../../../const/modalIds";
import { useConfig } from "../../../../hooks/useConfig";
import VantageLink from "../../../atoms/VantageLink";
import VantageTrans from "../../../atoms/VantageTrans";
import CreditInfluences from "../CreditInfluences";
import CreditTipCard from "../CreditTipCard";
import { ButtonWrapper, CreditButton, ExternalLink, StaticWrapper, } from "./subcomponents";
import UnenrollModalPopUp from "./UnenrollModal";
import UnenrollSuccessModalPopUp from "./UnenrollSuccessModal";
import useRestoreFocus from "../../../../hooks/useRestoreFocus";
var CreditScoreStaticContent = function (_a) {
    var vantageEnrolledAccounts = _a.vantageEnrolledAccounts;
    var queryClient = useQueryClient();
    var assets = useConfig().hosts.assets;
    var _b = useRestoreFocus(), ref = _b.ref, restoreFocusToRef = _b.restoreFocusToRef;
    var creditScorePdf = "".concat(assets.origin, "/assets/vantage/credit-score-quick-guide.pdf");
    var _c = useState({
        successModal: {
            isOpen: false,
            containerId: "",
        },
        unenrollModal: {
            isOpen: false,
            containerId: "",
        },
    }), modals = _c[0], setModals = _c[1];
    var handleOpenModal = function (modalKey, containerId) {
        var _a;
        setModals(__assign(__assign({}, modals), (_a = {}, _a[modalKey] = {
            isOpen: true,
            containerId: containerId,
        }, _a)));
    };
    var handleCloseModal = function (modalKey) {
        var _a;
        setModals(__assign(__assign({}, modals), (_a = {}, _a[modalKey] = {
            isOpen: false,
            containerId: "",
        }, _a)));
    };
    var switchModalState = function () {
        setModals({
            successModal: {
                isOpen: true,
                containerId: modalIds.UNENROLL_SUCCESS_MODAL_ID,
            },
            unenrollModal: {
                isOpen: false,
                containerId: "",
            },
        });
    };
    var handleResetQueries = function () {
        vantageEnrolledAccounts.forEach(function (accountId) {
            queryClient.resetQueries({
                queryKey: accountSummaryV2CacheKey({
                    accountId: accountId,
                    accountIdType: "guid",
                }),
                exact: true,
            });
        });
    };
    return (_jsxs(StaticWrapper, __assign({ id: modalIds.UNENROLL_MODAL_ID }, { children: [_jsx(CreditInfluences, {}), _jsx(CreditTipCard, {}), _jsx(Body, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.disclaimers.thirdParty" }) }), _jsx(Stack, { size: "large" }), _jsx(VantageTrans, { i18nKey: "creditScorePage.disclaimers.transUnion", components: {
                    link1: (_jsx(VantageLink, { to: links.ANNUAL_CREDIT_LINK, isExternal: true, id: "annual-credit-report" })),
                    link2: (_jsx(VantageLink, { to: links.DISPUTE_LINK, isExternal: true, id: "transunion-dispute" })),
                } }), _jsx(Stack, { size: "large" }), _jsx(VantageTrans, { i18nKey: "creditScorePage.disclaimers.creditRepair" }), _jsx(Stack, { size: "xxlarge" }), _jsxs(ButtonWrapper, { children: [_jsx(CreditButton, __assign({ href: creditScorePdf, target: "_blank", "data-object": "link", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "learn more about improve score" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.links.learnMore" }) })), _jsx(Stack, { size: "large" }), _jsx(ExternalLink, __assign({ buttonType: "text", onClick: function () {
                            return handleOpenModal("unenrollModal", modalIds.UNENROLL_MODAL_ID);
                        }, ref: ref, "data-object": "link", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "unenroll your credit score" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.links.unenroll" }) }))] }), _jsx(UnenrollModalPopUp, { isOpen: modals.unenrollModal.isOpen, vantageEnrolledAccounts: vantageEnrolledAccounts, onClose: function () {
                    handleCloseModal("unenrollModal");
                    restoreFocusToRef();
                }, openSuccessModal: switchModalState }), _jsx(UnenrollSuccessModalPopUp, { isOpen: modals.successModal.isOpen, onClose: function () {
                    handleResetQueries();
                    handleCloseModal("successModal");
                } }), _jsx(Stack, { size: "xxlarge" })] })));
};
export default CreditScoreStaticContent;
